import React, { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Home from "./decks/Home";
import NotFound from "./decks/NotFound";

const ScrollAnchor = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [hash]);
  return null;
};

const App = () => (
  <>
    <ScrollAnchor />
    <Routes>
      <Route path="/"          element={<Home />} />
      <Route path="/craft"     element={<Navigate to="/#craft"    replace />} />
      <Route path="/practice"  element={<Navigate to="/#practice" replace />} />
      <Route path="/sectors"   element={<Navigate to="/#sectors"  replace />} />
      <Route path="/contact"   element={<Navigate to="/#contact"  replace />} />
      <Route path="*"          element={<NotFound />} />
    </Routes>
  </>
);

export default App;
